import template from './template.html';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      type: '='
    },
    controller: [
      '$scope',
      ($scope) => {
        const types = ['COVER', 'TICKET', 'TABLE', 'PACKAGE'];

        if (!types.includes($scope.type)) {
          $scope.type = 'UNKNOWN';
        }
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/inventoryIcon/index.js